import React from "react";
import { Button } from "../../ui/button";
import { cn } from "../../../lib/utils";

const TablePagination = ({ page, onPageChange, lastPage = 1 }: any) => {
  const handleOnNextClick = () => {
    if (page === lastPage) return;
    onPageChange(page + 1);
  };

  const handleOnPrevClick = () => {
    if (page === 1) return;
    onPageChange(page - 1);
  };

  return (
    <div className="flex">
      <Button
        style={{
          borderRight: "0",
        }}
        className={cn("rounded-r-none", {
          "cursor-not-allowed": page === 1,
        })}
        onClick={handleOnPrevClick}
      >
        Prev
      </Button>

      <div className="flex border-4 border-primary bg-primary font-bold w-12 h-full items-center justify-center">
        <div className="rounded-[10%] bg-blackLight /bg-primary w-full h-full flex items-center justify-center">
          {page}
        </div>
      </div>

      <Button
        style={{
          borderLeft: "0",
        }}
        className={cn("rounded-l-none", {
          "cursor-not-allowed": page === lastPage,
        })}
        onClick={handleOnNextClick}
      >
        Next
      </Button>
    </div>
  );
};

export default TablePagination;
